module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "North Falls targeted consultation",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--north-falls-targeted.netlify.app' : 'https://targetedconsultation.northfallsoffshore.com',
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? 'https://targetedfeedbackmap.northfallsoffshore.com' : 'https://targetedfeedbackmap.northfallsoffshore.com',

    base: {
        "contact_address": "",
        "contact_number": "",
        "contact_email": ""
    },

    holding: {
        "brand": "/assets/images/north-falls-main.png",
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "North Falls statutory consultation",
        "description": "North Falls statutory consultation",
        "gtag": "G-15KJYRYTD2",
        "gtm": "GTM-WRBMDJF5"
    },

    form: {
        "register": {
            "catcher_id": "8b216d9cd6c0257c7c5eff7a7e7eaf72",
            "honeypot": "9191e45b94062a122a1940f345a266e9",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b"
        },

        "feedback": {
            "catcher_id": "40dcb1bf6a310666817d8566cab63812",
            "honeypot": "9191e45b94062a122a1940f345a266e9",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b"
        }
    },

    consultation: {
        "feedback_active": false,
        "start_datetime": "Tuesday May 16 2023",
        "end_datetime": "Friday July 14 2023"
    },

    hasMap: true,

    // Bugsnag API Key
    bugsnagApiKey: "", //9e4a239bfdc3d27e4d6f0698059c3f4f

    // Marker.io Key - replace this default key
	marker_io: "65e84698e87b50952dafc61b",
};
